import { FC } from 'react'

interface TreasuriesDotProps {
  cx?: number
  cy?: number
  className?: string
}

export const TreasuriesDot: FC<TreasuriesDotProps> = ({ className, cx = 0, cy = 0 }) => (
  <svg x={cx - 12} y={cy - 12} width={24} height={24} viewBox="0 0 24 24" fill="none" className={className}>
    <g opacity="0.7" clipPath="url(#clip0_2657_45420)">
      <path
        d="M24.0069 12C24.0069 18.6271 18.6325 24 12.0038 24C5.37518 24 0 18.6271 0 12C0 5.37288 5.37442 0 12.0031 0C18.6317 0 24.0061 5.37288 24.0061 12H24.0069ZM23.2551 12.7265V11.1577H12.3475L12.2324 11.0426V9.32123H22.8723L22.3369 7.56147H12.3483L12.2332 7.4464V5.72499H21.2652C21.0957 5.34987 20.772 4.92105 20.4973 4.61727C20.2918 4.39021 20.0601 4.18692 19.8491 3.96446H12.2332V2.24305L12.3483 2.12798H17.3621L15.9829 1.479C8.37461 -1.46212 0.115835 4.75459 0.783993 12.8461L23.2544 12.7265H23.2551ZM22.8723 14.678H1.1338C1.16218 15.0746 1.29489 15.4973 1.43834 15.8655C1.51505 16.0626 1.57642 16.4009 1.78278 16.4393L22.3239 16.4255L22.8716 14.678H22.8723ZM21.2645 18.2742H2.74091C2.92041 18.6632 3.25641 19.1096 3.54331 19.4234C3.68293 19.576 4.06878 20.001 4.23525 20.0325L19.8852 19.9949C20.0739 19.8023 20.2803 19.6221 20.4621 19.4234C20.5518 19.326 21.3404 18.3387 21.2645 18.2742ZM17.3606 21.8713H6.72147L8.02404 22.5202C10.5701 23.4715 13.3731 23.4807 15.9261 22.5402L17.3614 21.8705L17.3606 21.8713Z"
        fill="white"
      />
      <path
        d="M10.629 3.02697L11.4606 3.03848L10.843 3.54938L11.0778 4.33797C10.9811 4.41929 10.5577 3.95288 10.3505 3.95902C10.1687 3.96439 9.78364 4.42543 9.70079 4.33797L9.8918 3.56856C9.86035 3.4742 9.17685 3.15124 9.318 3.03771L10.1565 3.03388L10.3513 2.27136L10.6298 3.02697H10.629Z"
        fill="white"
      />
      <path
        d="M6.9433 2.34956L7.17266 3.00084L7.93901 3.03843C7.98274 3.21487 7.90603 3.16424 7.84236 3.21334C7.71732 3.30999 7.37365 3.45881 7.3422 3.62221L7.55545 4.3387L6.83206 3.95284L6.17771 4.3387L6.41245 3.5501L5.79492 3.0392L6.62801 3.02923C6.65179 3.00852 6.75382 2.55362 6.78987 2.46386C6.82593 2.37411 6.7308 2.31888 6.94176 2.35033L6.9433 2.34956Z"
        fill="white"
      />
      <path
        d="M10.6358 10.6123L11.4673 10.623L10.8628 11.1332L11.0845 11.9225L10.3581 11.4891L9.70755 11.9233L9.89856 11.1554L9.24805 10.623L10.0934 10.587L10.3205 9.85669C10.5552 9.91192 10.5437 10.5525 10.6358 10.6115V10.6123Z"
        fill="white"
      />
      <path
        d="M6.94371 9.92491L7.17155 10.5785L7.9402 10.6145L7.3687 11.1454L7.55664 11.914L6.90613 11.4799L6.17967 11.9133L6.4144 11.1247L5.79688 10.6138L6.6315 10.6053C6.67599 10.4304 6.71128 10.1919 6.78492 10.0323C6.82558 9.94408 6.7481 9.89345 6.94371 9.92491Z"
        fill="white"
      />
      <path
        d="M3.58728 10.6007L4.41653 10.6145L3.76602 11.1461L3.95703 11.914L3.30652 11.4806L2.65677 11.914L2.79945 11.127L2.19727 10.6145L3.02805 10.603L3.30652 9.84741L3.58728 10.6007Z"
        fill="white"
      />
      <path
        d="M10.6341 6.86482L11.392 6.87326L10.8665 7.38569L11.0859 8.17275L10.3718 7.72706L9.70973 8.17352L9.91608 7.36574L9.32617 6.87326L10.0964 6.83874L10.3227 6.10767C10.4308 6.02252 10.6379 6.77276 10.6356 6.86482H10.6341Z"
        fill="white"
      />
      <path
        d="M7.93943 6.86486L7.33724 7.36886L7.55587 8.16436L6.89385 7.71866L6.17967 8.16436L6.39906 7.37576L5.79688 6.86486L6.56322 6.82727L6.94371 6.09851L7.17078 6.82881L7.93943 6.86486Z"
        fill="white"
      />
      <path
        d="M3.58444 6.85335L4.33928 6.86486L3.74553 7.35812L3.95649 8.08764L3.30751 7.70409L2.65623 8.08764L2.88253 7.32897L2.27344 6.86409C3.07661 6.97993 3.04209 6.71987 3.30751 6.09851L3.58597 6.85259L3.58444 6.85335Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2657_45420">
        <rect width="24.0069" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
